module.exports = __webpack_public_path__ + "static/img/Bradman-Best.5a3673e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Bradman-Best.jpg
// module id = yzfp
// module chunks = 0